import type { CheckInPhoto } from '@techgitter/contracts';

/**
 * Where a photo's download control points. `downloadUrl` is a link the API
 * signs with Content-Disposition: attachment, so the browser saves the file in
 * place — the photo is cross-origin, where `<a download>` is ignored. An API
 * predating it gets the view link opened in a tab, where it can be saved.
 * Null when there is no link at all. Shared by the thumbnail and the viewer.
 */
export function photoDownloadLink(photo: CheckInPhoto): { href: string; target?: '_blank' } | null {
  if (photo.downloadUrl) return { href: photo.downloadUrl };
  const view = photo.signedUrl || photo.blobUrl;
  return view ? { href: view, target: '_blank' } : null;
}
